export enum MESSAGE {
  CHANGES_SAVED = 'Changes have been saved',
}

export enum NOTIFICATION_MESSAGE {
  ADDED_TO_FAVORITES = 'Added to My List',
  REMOVED_FROM_FAVORITES = 'Removed from My List',
  ACCOUNT_CREATED = 'Account created successfully',
}
